var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"center-block",attrs:{"variant":_vm.alertType,"show":_vm.dismissCountDown,"dismissible":""},on:{"dismissed":_vm.dismissed,"dismiss-count-down":_vm.countDownChanged}},[_vm._v(_vm._s(_vm.alertBody))])}
var staticRenderFns = []

export { render, staticRenderFns }